import { BuilderModel } from "../Models/BuilderModel";

export class BuilderModelFactory
{
    static CreateDefault(): BuilderModel
    {
        return new BuilderModel();
    }

    static FromStorage(json: string): BuilderModel
    {
        return Object.assign(new BuilderModel(), JSON.parse(json));
    }
}
